import { useLang } from "@/context/LanguageContext";

function FlagIT({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className="rounded-[3px]" aria-hidden>
      <rect width="8" height="24" x="0" fill="#009246" />
      <rect width="8" height="24" x="8" fill="#ffffff" />
      <rect width="8" height="24" x="16" fill="#ce2b37" />
    </svg>
  );
}

function FlagGB({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className="rounded-[3px]" aria-hidden>
      <rect width="24" height="24" fill="#012169" />
      <path d="M0 0l24 24M24 0L0 24" stroke="#fff" strokeWidth="4" />
      <path d="M0 0l24 24M24 0L0 24" stroke="#C8102E" strokeWidth="2" />
      <path d="M12 0v24M0 12h24" stroke="#fff" strokeWidth="6" />
      <path d="M12 0v24M0 12h24" stroke="#C8102E" strokeWidth="3" />
    </svg>
  );
}

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex items-center gap-1 ${className}`} data-testid="lang-toggle">
      <button
        type="button"
        onClick={() => setLang("it")}
        title="Italiano"
        aria-label="Italiano"
        data-testid="lang-it"
        className={`p-1 rounded-sm border transition-all ${lang === "it" ? "border-primary ring-1 ring-primary/50 opacity-100" : "border-transparent opacity-50 hover:opacity-90"}`}
      >
        <FlagIT />
      </button>
      <button
        type="button"
        onClick={() => setLang("en")}
        title="English"
        aria-label="English"
        data-testid="lang-en"
        className={`p-1 rounded-sm border transition-all ${lang === "en" ? "border-primary ring-1 ring-primary/50 opacity-100" : "border-transparent opacity-50 hover:opacity-90"}`}
      >
        <FlagGB />
      </button>
    </div>
  );
}
